
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/kamu-kimlik-yonetimi",
      function () {
        return require("private-next-pages/solutions/kamu-kimlik-yonetimi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/kamu-kimlik-yonetimi"])
      });
    }
  